export default { sha: '7c625d1a151cf5def82497ff7702859a484aa483', buildNumber: 'undefined' }
